// extracted by mini-css-extract-plugin
export default {"more_tabs":"index_more_tabs_aRFTw","title":"index_title_HoIJ8","more":"index_more_F-RqC"};